
const state = {
    selectProject: null,  // 数据源接入： 当前的项目id
    selectDeviceGroup: null,  // 选中的设备分组信息  用于查询列表

    // 选中，正在操作的数据
    selectedTableData: null,  //采集数据接入：table 中正在操作的数据
    // 选中的设备信息
    selectedDevice: null,  // 选中的设备信息  用于查询点位
    selectedCaptureDevice: null,  // 获取添加/编辑采集任务时选中的设备信息
};

//操作管理
const mutations = {
    SET_SELECTED_PROJECT(state, data = null) {
        state.selectProject = data
    },
    SET_SELECTED_DEVICE_GROUP(state, data = null) {
        state.selectDeviceGroup = data
    },

    SET_SELECTED_TABLE_DATA(state, data = null) {
        state.selectedTableData = data
    },
    SET_SELECTED_DEVICE(state, data = null) {
        state.selectedDevice = data
    },
    SET_SELECTED_CAPTURE_DEVICE(state, data = null) {
        state.selectedCaptureDevice = data
    },

}

// 异步操作
const actions = {
    // 设置选中的项目id
    setSelectedProject({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_PROJECT", data);
    },
    // 设置选中的设备分组信息
    setSelectedDeviceGroup({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_DEVICE_GROUP", data);
    },
    // 设置当前  采集数据接入类型任务列表
    setSelectedTableData({ commit }, data = null){
        commit('SET_SELECTED_TABLE_DATA', data)
    },



    //选中的设备列表
    setSelectedDevice({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_DEVICE", data);
    },

    //todu:未用
    setSelectedCaptureDevice({ commit }, data = null) {
        commit('SET_SELECTED_CAPTURE_DEVICE', data)
    }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
